import React from 'react';
import { formatMonthLabel, monthDistanceLabel } from '../utils/month.js';

/**
 * Names the month currently at the top of the calendar, and offers the one
 * navigation control there is: jump back to today. Everything else is
 * reached by scrolling.
 *
 * The Today button always works — it is only greyed out while the view is
 * already parked exactly where it would take you.
 *
 * @param {string} monthKey month in view
 * @param {string} currentMonthKey month containing today
 * @param {boolean} atToday view is already at the jump target
 * @param {() => void} onToday
 */
export default function MonthBar({ monthKey, currentMonthKey, atToday, onToday }) {
  return (
    <div className="flex items-center justify-between gap-3 border-y border-line py-2.5">
      <div className="min-w-0">
        <div className="truncate font-display text-base uppercase tracking-tight sm:text-lg">
          {formatMonthLabel(monthKey)}
        </div>
        <div className="font-hand text-lg leading-none text-ink-soft">
          {monthDistanceLabel(monthKey, currentMonthKey)}
        </div>
      </div>

      <button
        type="button"
        onClick={onToday}
        className={`pill-btn shrink-0 text-xs uppercase tracking-widest ${
          atToday ? 'border-line text-ink-soft' : 'pill-btn--accent'
        }`}
      >
        Today
      </button>
    </div>
  );
}
